module.exports = __webpack_public_path__ + "img/instruction_video_trigger.1fe9af97.jpg";